module.exports = __webpack_public_path__ + "static/media/my_pic_3.b5bab85e.JPG";